import { useEffect, useState } from "react";
import { _single, _WelfareEntityType } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { PayrollTypeWelfareType } from "./PayrollTypeWelfareType/PayrollTypeWelfareType";


export const WelfareEntityType = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_WelfareEntityType);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalConfig, setModalConfig] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getWelfareEntityTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(
            err => { console.log(err) }
        )

    }

    const create = () => {
        setBean({});
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        instance.deleteWelfareEntityType(bean.IDWelfareEntityType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false, "name": "Crear Tipo de Entidad de Salud y Bienestar Social" });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        instance.updateWelfareEntityType(bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDWelfareEntityType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Cuenta por Pagar', property: 'PaymentAccountantIDStrName', visible: true },
        { title: 'ExpensiveAccountantIDStr', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Configuración de Cuenta/Rubro por Tipo de Payroll', icono: 'ri-list-ordered', visible: true, evento: () => { setModalConfig({ ...modalConfig, "view": true, "name": "Configuración de Cuenta/Rubro por Tipo de Payroll" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipo de Entidades de Salud y Bienestar Social">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} />

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, "Name": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "PaymentAccountantIDStr": e.JsonCode }) }} jsonCode={bean.PaymentAccountantIDStr} label="Cuenta por Pagar" />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree onChange={(e) => { setBean({ ...bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} jsonCode={bean.ExpensiveAccountantIDStr} label="Cuenta de Gasto" />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} label="Rubro Presupuestal" />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                    <Modal modal={modalConfig} updateModal={setModalConfig} eventModal={deleteItem}>
                        <PayrollTypeWelfareType idWelfareEntityType={bean.IDWelfareEntityType} />
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}